import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-share-web-layout',
    templateUrl: './share-web-layout.component.html',
    styleUrls: ['./share-web-layout.component.scss'],
    standalone: false
})
export class ShareWebLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
